import { useLegalModalStore } from '@common/stores/legal-modal-store';
import { Button } from '@konova/ui/button';
import { Modal } from '@konova/ui/modal';
import { Stack } from '@konova/ui/stack';
import { Typography } from '@konova/ui/typography';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type RegisterExplanationModalProps = {
  show: boolean;
  onClose: () => void;
};

export const RegisterExplanationModal: FC<RegisterExplanationModalProps> = ({
  show,
  onClose,
}) => {
  const [t] = useTranslation();
  const setShowPrivacyModal = useLegalModalStore(state => state.setShowPrivacyModal);
  const showPrivacyModal = () => setShowPrivacyModal(true);

  return (
    <Modal
      footer={<Button onClick={onClose}>{t('common.close')}</Button>}
      size="lg"
      open={show}
      onClose={onClose}
      title={t('pages.login.registration-explanation.title')}
      label={t('pages.login.registration-explanation.title')}
    >
      <Stack direction="column" fill spacing={3}>
        <Typography bold>{t('pages.login.registration-explanation.text1')}</Typography>
        <Typography>
          {t('pages.login.registration-explanation.text2')}
          {' '}
          <Button variant="link" inline onClick={showPrivacyModal}>
            {t('pages.login.registration-explanation.link')}
          </Button>
        </Typography>
        <Typography>{t('pages.login.registration-explanation.bottom-text')}</Typography>
      </Stack>
    </Modal>
  );
};
